<template>
  <div>
    <van-cell class="ry-form__phone" v-if="isNormalStyle">
      <template slot="title">
        <span class="title">{{current.title}}</span>
        <span style="color: red" v-if="!isRead && current.required">*</span>
      </template>
      <template slot="label">

        <template v-if="current.fieldHint">
          <froalaView v-if="$store.getters.newRtf" v-model="current.fieldHint"></froalaView>
          <div
            v-else
            class="ql-editor"
            v-html="current.fieldHint">
          </div>
        </template>
        <div
          v-if="isRead"
          v-html="content">
        </div>
        <template v-if="!isRead">
          <van-field
            class="ry-form__phone-input"
            :readonly="isReadOnly"
            @focus="phoneFocus"
            @blur="phoneBlur"
            @change="phoneNumChange"
            type="tel"
            v-model="current.value"
            :placeholder="current.fieldDes"
            :error-message="errorMessage">
          </van-field>
          <van-field
            style="padding: 0 !important;"
            :readonly="isReadOnly"
            maxlength="4"
            @blur="codeChange"
            placeholder="请输入短信验证码"
            v-model="current.authCode"
            type="digit"
            :error-message="codeErrorMessage"
            v-if="!isRead && current.codeCheck && !current.root.stepId">
            <van-button
              slot="button"
              size="small"
              :disabled="isSending"
              @click="getAuthCode"
              type="primary">
              {{codeButtonContent}}
            </van-button>
          </van-field>
        </template>

      </template>
    </van-cell>


    <div v-else class="ry-form-item-compact ry-form__phone-compact">


      <van-field
        :label="current.title"
        :label-class="{'readonly-field-label': !isRead && isReadOnly}"
        :required="Boolean(!isRead && current.required)">
        <template #input>
          <div
            v-if="isRead"
            v-html="content">
          </div>
          <div v-else class="ry-form__phone-compact-container">
            <van-field
              class="ry-form__phone-input"
              :readonly="isReadOnly"
              @focus="phoneFocus"
              @blur="phoneBlur"
              @change="phoneNumChange"
              type="tel"
              v-model="current.value"
              :placeholder="isReadOnly ? '暂无内容' : '请填写手机号码'">
            </van-field>
            <van-field
              style="padding: 0 !important;"
              :readonly="isReadOnly"
              maxlength="4"
              @blur="codeChange"
              placeholder="请输入短信验证码"
              v-model="current.authCode"
              type="digit"
              :error-message="codeErrorMessage"
              v-if="!isRead && current.codeCheck && !current.root.stepId">
              <van-button
                slot="button"
                size="small"
                :disabled="isSending || isReadOnly"
                @click="getAuthCode"
                type="primary">
                {{codeButtonContent}}
              </van-button>
            </van-field>
          </div>
        </template>
      </van-field>
    </div>
  </div>

</template>

<script>
  import { phones } from '../../Regex'
  import { current } from './mixin'
  import { CHECK_CODE_ERROR, SUCCESS } from '../types'
  import {selectPhoneNumberAndUrl} from "../../../assets/js/Untis";

  export default {
    mixins: [current],
    data () {
      return {
        isError: false,
        isSending: false,
        codeButtonContent: '发送验证码',
        isCodeError: false,
        timer: null
      }
    },
    computed: {

      content() {
        return this.current.value && this.current.value.length ? selectPhoneNumberAndUrl(this.current.value) : '暂无内容'
      },
      errorMessage () {
        return this.isError ? '手机号格式错误' : ''
      },
      codeErrorMessage () {
        return this.isCodeError ? '验证码错误' : ''
      }
    },
    methods: {
      // 手机输入框失焦
      phoneBlur () {
        if (phones['+86'].pattern.test(this.current.value)) {
          this.controlChange()
        } else {
          this.isError = true
        }
      },
      // 手机号输入框聚焦
      phoneFocus () {
        this.isError = false
      },
      phoneNumChange() {
        this.isSending = false
        if (this.codeButtonContent === '已验证') {
          this.codeButtonContent = '发送验证码'
        }
      },
      // 获取验证码
      getAuthCode () {
        if (this.isReadOnly) {
          return
        }
        if (phones['+86'].pattern.test(this.current.value)) {
          this.$store.dispatch('userCodeGet', {
            countryCode: '+86',
            companyId: this.$store.getters.currentCompanyId,
            telephone: this.current.value
          }).then(({ status, info }) => {
            if (status === SUCCESS) {
              this.isSending = true
              this.countDown(60)
            } else {
              this.$toast.fail(info)
            }
          }).catch(console.error)
        } else {
          this.$toast.fail('手机格式有误')
        }
      },
      // 验证码倒计时
      countDown (n) {
        this.timer = setTimeout(() => {
          this.codeButtonContent = `${n}s`
          if (n > 0) {
            this.countDown(--n)
          } else {
            this.isSending = false
            this.codeButtonContent = '发送验证码'
          }
        }, 1000)
      },
      // 验证码输入框值变化时触发
      codeChange () {
        // 正在发送验证码 或者已验证通过 不提交接口
        if (!this.current.value || !phones['+86'].pattern.test(this.current.value)) {
          this.$toast.fail('手机格式有误')
          return
        }
        console.log('isSending',this.isSending)
        if (this.current.authCode.length === 4) {
          this.$store.dispatch('actionPhoneFieldCheckCode', {
            phone: this.current.value,
            code: this.current.authCode
          }).then(({ status, resultObject, info }) => {
            if (status === CHECK_CODE_ERROR) {
              this.$toast.fail('验证码有误')
              this.isCodeError = true
              this.current.codeThroughCheck = false
            } else if (status === SUCCESS) {
              this.$toast.success('验证通过')
              clearTimeout(this.timer)
              // 验证已通过将发送验证码 按钮关闭掉 改变按钮文案
              this.isSending = true
              this.codeButtonContent = '已验证'

              this.isCodeError = false
              this.current.codeThroughCheck = true
            } else {
              this.$toast.fail('验证失败')
              this.isCodeError = false
              this.current.codeThroughCheck = false
            }
          }).catch(console.error)
        } else {
          this.isCodeError = true
        }
      }
    },
    components: {},
    watch: {}
  }
</script>
